import React from "react"
import { Breadcrumb } from "antd"
import { Link } from "react-router-dom"

import { pageRoute } from "features/Docs/manifest"
import { DocsSection, DocsPage } from "features/Docs/types/docs.types"

interface DocsBreadcrumbsProps {
  section: DocsSection
  page: DocsPage
}

/** Docs / Section / Page trail. The section links to its first page. */
const DocsBreadcrumbs: React.FC<DocsBreadcrumbsProps> = ({ section, page }) => (
  <Breadcrumb
    className="docs-breadcrumbs"
    items={[
      { title: <Link to="/docs">Docs</Link> },
      {
        title: (
          <Link to={pageRoute(section.slug, section.pages[0].slug)}>
            {section.title}
          </Link>
        ),
      },
      { title: page.title },
    ]}
  />
)

export default DocsBreadcrumbs
